// src/components/AdminRoute.jsx
import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { me } from '../Admin/adminApi';
import { isLoggedIn } from '../utils/auth';
import { buildLoginUrl } from '../utils/authRedirect';

export default function AdminRoute({ children }) {
  const token = localStorage.getItem('token');
  const location = useLocation();
  const [allowed, setAllowed] = useState(null); // null=loading, true|false

  useEffect(() => {
    let isMounted = true;
    (async () => {
      if (!token) { if (isMounted) setAllowed(false); return; }
      const u = await me(token);
      if (isMounted) setAllowed(u?.role === 'admin');
    })();
    return () => { isMounted = false; };
  }, [token]);

  if (allowed === null) return null; // oppure spinner

  if (!allowed) {
    // Redirect solo se non loggato: un utente loggato ma non admin (o me()
    // fallita) tornerebbe qui dal login -> loop. In quel caso, login semplice.
    const to = isLoggedIn() ? "/login" : buildLoginUrl(location);
    return <Navigate to={to} replace />;
  }

  return children;
}
